import { render, staticRenderFns } from "./ShortTermOpportunityGrid.vue?vue&type=template&id=22d13c1b&scoped=true&"
import script from "./ShortTermOpportunityGrid.vue?vue&type=script&lang=js&"
export * from "./ShortTermOpportunityGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d13c1b",
  null
  
)

/* custom blocks */
import block0 from "@/javascripts/grid.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fapp%2Fjavascript%2Fpages%2FDomainSearch%2FOpportunityAndSea%2FShortTermOpportunityGrid.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./ShortTermOpportunityGrid.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports